import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=64fddd5d&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fddd5d')) {
      api.createRecord('64fddd5d', component.options)
    } else {
      api.reload('64fddd5d', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=64fddd5d&", function () {
      api.rerender('64fddd5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W11z5WKS4bCC/JS/comp/ImgFallback.vue"
export default component.exports